<template>
  <div>
    <common-header></common-header>
    <div class="models">
      <!-- 模块一：即开即中 -->
      <section class="module">
        <div class="module-head">
          <div class="module-title">
            <span class="bar"></span>
            <div class="title-text">
              <h2>即开即中</h2>
              <p>参与即可马上开奖，玩法丰富、趣味性强，适合各类营销场景快速引流。</p>
            </div>
          </div>
          <div class="module-actions">
            <el-button @click="goList" plain>发起列表</el-button>
            <el-button type="primary" @click="goCreate({ version_id: 3 })">我要发起即开即中抽奖</el-button>
          </div>
        </div>

        <div class="instant-grid">
          <div
            class="instant-card"
            v-for="item in instantItems"
            :key="item.type"
            @click="goCreate({ version_id: 3, lottery_type: item.type, skin_id: 0 })"
          >
            <div class="instant-icon">
              <img :src="item.img" :alt="item.name" />
            </div>
            <div class="instant-info">
              <div class="instant-name">{{ item.name }}</div>
              <div class="instant-desc">{{ item.desc }}</div>
            </div>
            <div class="instant-go">
              <span>创建</span>
              <i class="el-icon-arrow-right"></i>
            </div>
          </div>
        </div>
        <div class="create-tips">
          <img class="icon" src="https://static.goubudian.com/Uploads/dzp/tips.png" alt="" />
          <span>请选择以上任意玩法创建活动</span>
        </div>
      </section>

      <!-- 模块二：通用抽奖 -->
      <section class="module">
        <div class="module-head">
          <div class="module-title">
            <span class="bar"></span>
            <div class="title-text">
              <h2>通用抽奖</h2>
              <p>按时间、人数自动开奖或手动开奖，灵活配置，适合活动裂变与用户沉淀。</p>
            </div>
          </div>
          <div class="module-actions">
            <el-button @click="goGeneralList" plain>发起列表</el-button>
            <el-button type="primary" @click="goCreateNomarl">我要发起通用抽奖</el-button>
          </div>
        </div>

        <div class="general-layout">
          <div
            class="general-card general-big"
            @click="goCreateNomarl"
          >
            <div class="general-name">手动开奖 | 现场大屏</div>
            <div class="general-desc">发起人手动开奖，适合现场促销、年会、庆典等各类现场抽奖活动。支持手机与电脑的跨终端互动。</div>
            <el-button class="general-btn" type="primary" size="small">去发起</el-button>
          </div>
          <div class="general-col">
            <div
              class="general-card general-small"
              @click="goCreateNomarl"
            >
              <div class="general-name">按时间开奖</div>
              <div class="general-desc">指定时间自动开奖，快速传播，低成本获客。支持现场大屏。</div>
              <i class="el-icon-arrow-right general-arrow"></i>
            </div>
            <div
              class="general-card general-small"
              @click="goCreateNomarl"
            >
              <div class="general-name">按人数开奖</div>
              <div class="general-desc">满人数后自动开奖。支持现场大屏。</div>
              <i class="el-icon-arrow-right general-arrow"></i>
            </div>
          </div>
        </div>
        <div class="create-tips">
          <img class="icon" src="https://static.goubudian.com/Uploads/dzp/tips.png" alt="" />
          <span>请选择以上任意玩法创建活动</span>
        </div>
      </section>

      <!-- 模块三：综合抽奖活动 -->
      <!-- <section class="module">
        <div class="module-head">
          <div class="module-title">
            <span class="bar"></span>
            <div class="title-text">
              <h2>综合抽奖活动</h2>
              <p>签到、倒计时、拼手速、投票等各类互动玩法。发起人可自行选择玩法，搭配设计现场互动的环节和效果。支持手机与电脑的跨终端互动。</p>
            </div>
          </div>
          <div class="module-actions">
            <el-button @click="goList" plain>发起列表</el-button>
            <el-button type="primary" @click="goCreate({ version_id: 1 })">我要发起综合抽奖</el-button>
          </div>
        </div>

        <div class="comprehensive">
          <div class="comprehensive-tags">
            <span class="tag" v-for="f in features" :key="f">{{ f }}</span>
          </div>
          <div class="comprehensive-desc">
            灵活组合多种互动环节，打造专属现场氛围；一次发起，多端联动，覆盖线上线下全场景。
          </div>
        </div>
      </section> -->
    </div>
    <common-footer></common-footer>
    <LoginBox ref="login"></LoginBox>

    <!-- 通用抽奖创建提示弹窗 -->
    <el-dialog
      title="创建通用抽奖"
      :visible.sync="showNomarlDialog"
      width="360px"
      center
    >
      <div class="nomarl-dialog" style="text-align: center;">
        <p class="nomarl-tip" style="font-size: 14px;color: #4a4a57;line-height: 1.8;margin: 4px 0 18px;">PC端暂不支持通用抽奖活动创建，<br />请扫码移步手机端创建。</p>
        <img :src="require('@/assets/image/code_create.jpg')" class="code_create" alt="小程序码" style="  width: 180px;height: 180px; border-radius: 8px; object-fit: contain;" />
        <p class="nomarl-sub" style=" font-size: 12px;color: #9a9aa6;margin-top: 12px;">微信扫一扫，手机端快速发起</p>
      </div>
      <div class="tips flex justify-center align-center" style="margin-top: 50px;">
        <el-button type="primary" class="btn" @click="goGeneralList">我的发起记录</el-button>
        <el-button class="btn" @click="showNomarlDialog = false">知道了</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import LoginBox from './loginBox.vue'
import CommonHeader from './header.vue'
import CommonFooter from './footer.vue'
export default {
  name: 'models',
  data() {
    return {
      // 即开即中玩法列表
      instantItems: [
        { type: 1, name: '幸运大转盘抽奖', desc: '惊喜转出来，趣味性十足', img: 'https://static.goubudian.com/Uploads/lottery/2209/631478dd68373.png' },
        { type: 2, name: '趣味九宫格', desc: '好礼大放送，适合奖项丰富的商家', img: 'https://static.goubudian.com/Uploads/lottery/2209/6314776b6465e.png' },
        { type: 3, name: '摇一摇拼手气', desc: '有礼才完美，适合100%中奖的商家', img: 'https://static.goubudian.com/Uploads/lottery/2209/6314777b07b84.png' },
        { type: 4, name: '扭蛋机', desc: '当下潮流玩法，好玩又惊喜', img: 'https://static.goubudian.com/Uploads/lottery/2209/6314778c5868f.png' },
        { type: 5, name: '幸运抽盲盒', desc: '当下潮流玩法，适合中奖率的商家', img: 'https://static.goubudian.com/Uploads/lottery/2506/683d00748259e.png' },
        { type: 6, name: '欢乐砸金蛋', desc: '简单好玩的抽奖玩法，更有氛围感', img: 'https://static.goubudian.com/Uploads/lottery/2506/683d014619a1b.png' }
      ],
      // 通用抽奖玩法列表（按时间/手动/按人数）
      generalItems: [
        { prize_type: 1, name: '按时间开奖' },
        { prize_type: 3, name: '手动开奖' },
        { prize_type: 2, name: '按人数开奖' }
      ],
      // 综合抽奖互动玩法标签
      features: ['签到', '倒计时', '拼手速', '投票'],
      // 通用抽奖创建提示弹窗
      showNomarlDialog: false
    }
  },
  components: {
    LoginBox,
    CommonHeader,
    CommonFooter
  },
  methods: {
    // 跳转到创建页，携带玩法相关参数
    goCreate(query) {
      this.$router.push({ path: '/create', query })
    },
    goCreateNomarl() {
      this.showNomarlDialog = true
    },
    // 跳转到发起列表
    goList() {
      this.$router.push('/list')
    },
    //跳转到通用发起列表
    goGeneralList() {
      this.$router.push('/nomarlList')
    },
    fetchData(){
      console.log('fetchData');

    },
  },
  mounted() {
    if (this.$cookie.getCookie('token') === '') {
      this.$refs.login.login_fn()
    }
  }
}
</script>
<style lang="scss" scoped>
.models {
  width: 1200px;
  margin: 24px auto 60px;
  .module {
    background: #fff;
    border-radius: 12px;
    padding: 28px 32px 32px;
    margin-bottom: 24px;
    box-shadow: 0 4px 18px rgba(0, 0, 0, 0.05);
  }
  .module-head {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 24px;
    .module-title {
      display: flex;
      align-items: flex-start;
      .bar {
        width: 5px;
        height: 42px;
        background: linear-gradient(180deg, #674eff, #9b7bff);
        border-radius: 3px;
        margin-right: 14px;
        flex-shrink: 0;
      }
      .title-text {
        h2 {
          font-size: 22px;
          font-weight: 700;
          color: #1f1f2c;
          margin: 0 0 6px;
        }
        p {
          font-size: 13px;
          color: #8a8a99;
          margin: 0;
          max-width: 720px;
          line-height: 1.6;
        }
      }
    }
    .module-actions {
      display: flex;
      gap: 12px;
      flex-shrink: 0;
    }
  }

  /* 即开即中网格 */
  .instant-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;
    .instant-card {
      display: flex;
      align-items: center;
      border: 1px solid #eee;
      border-radius: 10px;
      padding: 16px;
      cursor: pointer;
      transition: all 0.25s;
      &:hover {
        border-color: #674eff;
        box-shadow: 0 6px 18px rgba(103, 78, 255, 0.15);
        transform: translateY(-2px);
      }
      .instant-icon {
        width: 56px;
        height: 56px;
        flex-shrink: 0;
        margin-right: 14px;
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      .instant-info {
        flex: 1;
        min-width: 0;
        .instant-name {
          font-size: 15px;
          font-weight: 600;
          color: #1f1f2c;
          margin-bottom: 6px;
        }
        .instant-desc {
          font-size: 12px;
          color: #9a9aa6;
          line-height: 1.5;
        }
      }
      .instant-go {
        display: flex;
        align-items: center;
        color: #674eff;
        font-size: 13px;
        flex-shrink: 0;
        i {
          margin-left: 2px;
        }
      }
    }
  }

  /* 通用抽奖布局 */
  .general-layout {
    display: flex;
    gap: 16px;
    .general-big {
      flex: 1.2;
      min-height: 180px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 28px;
      border-radius: 10px;
      color: #fff;
      background: linear-gradient(135deg, #674eff, #9b7bff);
      cursor: pointer;
      transition: all 0.25s;
      &:hover {
        box-shadow: 0 8px 22px rgba(103, 78, 255, 0.3);
        transform: translateY(-2px);
      }
      .general-name {
        font-size: 22px;
        font-weight: 700;
        margin-bottom: 12px;
      }
      .general-desc {
        font-size: 14px;
        opacity: 0.9;
        margin-bottom: 20px;
      }
      .general-btn {
        align-self: flex-start;
        background: #fff;
        color: #674eff;
        border: none;
        font-weight: 600;
      }
    }
    .general-col {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 16px;
      .general-small {
        flex: 1;
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 24px;
        border: 1px solid #eee;
        border-radius: 10px;
        cursor: pointer;
        transition: all 0.25s;
        &:hover {
          border-color: #674eff;
          box-shadow: 0 6px 18px rgba(103, 78, 255, 0.15);
          transform: translateY(-2px);
        }
        .general-name {
          font-size: 18px;
          font-weight: 600;
          color: #1f1f2c;
          margin-bottom: 8px;
        }
        .general-desc {
          font-size: 13px;
          color: #9a9aa6;
        }
        .general-arrow {
          position: absolute;
          right: 24px;
          top: 50%;
          transform: translateY(-50%);
          color: #c0c0c8;
          font-size: 18px;
        }
      }
    }
  }

  /* 综合抽奖 */
  .comprehensive {
    border: 1px dashed #d6ccff;
    background: linear-gradient(135deg, #f6f3ff, #ffffff);
    border-radius: 10px;
    padding: 28px;
    .comprehensive-tags {
      display: flex;
      flex-wrap: wrap;
      gap: 12px;
      margin-bottom: 16px;
      .tag {
        padding: 8px 20px;
        background: #fff;
        border: 1px solid #d6ccff;
        border-radius: 20px;
        color: #674eff;
        font-size: 14px;
        font-weight: 500;
      }
    }
    .comprehensive-desc {
      font-size: 13px;
      color: #8a8a99;
      line-height: 1.7;
    }
  }

  /* 提示 */
  .create-tips {
    display: flex;
    align-items: center;
    margin-top: 20px;
    font-size: 13px;
    color: #b0b0bb;
    .icon {
      width: 16px;
      height: 16px;
      margin-right: 6px;
    }
  }

  /* 通用抽奖创建弹窗 */
  .nomarl-dialog {
    text-align: center;
    .nomarl-tip {
      font-size: 14px;
      color: #4a4a57;
      line-height: 1.8;
      margin: 4px 0 18px;
    }
    .code_create {
      width: 180px;
      height: 180px;
      border-radius: 8px;
      object-fit: contain;
    }
    .nomarl-sub {
      font-size: 12px;
      color: #9a9aa6;
      margin-top: 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/models.vue